import React from 'react';
import { dateDiff } from '../../utils/dateUtil';

const ArticleList = (props) => {
  const item = props.item || {};
  const title = item.title || item.name;
  const id = item.id || item.tid || item.aid;
  const time = item.create_time || item.ctime || item.r_time;
  const view_num = item.view_num || 0;
  const cover = item.cover_img || '';
  return (
    <a
      key={item.tid}
      className="p-r d-f p-t-16 p-r-16 p-b-16 p-l-16 b-c-1e252be8e8f3 l-c-b-n topic-dynamic-item"
      href={`/de/${id}`}
    >
      <div className="f-g-1 d-f f-d-c o-h">
        <div className="f-g-1 m-b-20">
          <div className="o-h f-s-16 f-w-b l-h-1375 c-191c27 t-o-e l-c-2">{title}</div>
        </div>
        <div className="d-f f-b-c o-h f-s-12 l-h-116667 c-9ea5bb">
          <div className="o-h w-s-n t-o-el">{item.from_source ? `${item.from_source}` : ''}</div>
          {!!view_num && <div className="f-s-0 m-l-13"><span className="m-r-10">{dateDiff(time * 1000)}</span>{view_num} 阅读</div>}
        </div>
      </div>
      {!!cover && (
        <div className="f-s-0 p-r m-l-10 w-100 h-80">
          <img alt="" src={cover} className="w-100p h-100p o-f-c b-r-4" />
        </div>
      )}
    </a>
  );
};

export default ArticleList;
